<div class="details-body-wrapper">
  <app-orders [entity_id]="entity_id" [hideTitle]="false"></app-orders>
</div>
